import { useAppDispatch } from './state'
import { getQuestions as getQuestionsAPI } from '../api/questions'
import { setQuestions } from '../state/slices/questions_slice'

export const useQuestions = () => {
  const dispatch = useAppDispatch()

  const getQuestions = async () => {
    try {
      const result = await getQuestionsAPI()

      if (result.data.frequentlyAskedQuestions) {
        dispatch(setQuestions(result.data.frequentlyAskedQuestions))
      }

      return true
    } catch (error) {
      return false
    }
  }

  return {
    getQuestions
  }
}

export default useQuestions
